import { create } from 'zustand';

const permissions = [
  'integration:install',
  'integration:read',
  'integration:uninstall',
  'member:delete',
  'member:invite',
  'member:read',
  'member:change-role',
  'schedule:create',
  'schedule:delete',
  'schedule:member:add',
  'schedule:member:delete',
  'schedule:member:reorder',
  'schedule:read',
  'schedule:update',
  'organization:update',
  'organization:create',
  'rotation:create',
  'rotation:delete',
  'action:create',
  'action:delete',
  'action:test',
  'action:read',
  'billing:update',
] as const;

export type Permission = (typeof permissions)[number];

interface PermissionsState {
  permissions: Permission[];
  setPermissions: (permissions: Permission[]) => void;
  hasAnyPermission: (permissionsToCheck: Permission[]) => boolean;
  clearPermissions: () => void;
}

export const usePermissionsStore = create<PermissionsState>((set, get) => ({
  permissions: [],

  setPermissions: (permissions) => {
    set({ permissions });
  },

  hasAnyPermission: (permissionsToCheck) => {
    return get().permissions.some((permission) =>
      permissionsToCheck.includes(permission)
    );
  },

  clearPermissions: () => {
    set({ permissions: [] });
  },
}));
